import {type ApolloQueryResult} from 'apollo-client';

import {apolloClientNoCache} from '../../../../apolloClient';
import {
  BackendLinesDeltaQueryDocument,
  BackendLinesDeltaQueryInternalIdDocument,
  type BackendLinesDeltaQueryInternalIdQuery,
  type BackendLinesDeltaQueryInternalIdQueryVariables,
  type BackendLinesDeltaQueryQuery,
  type BackendLinesDeltaQueryQueryVariables,
  type BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
  BucketedRunsDeltaQueryWithoutRunInfoDocument,
  type BucketedRunsDeltaQueryWithoutRunInfoQuery,
  type BucketedRunsDeltaQueryWithoutRunInfoQueryVariables,
  GroupedBackendLinesDeltaQueryDocument,
  type GroupedBackendLinesDeltaQueryQuery,
  type GroupedBackendLinesDeltaQueryQueryVariables,
  GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument,
  type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
  type GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables,
  GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument,
  type GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery,
  type GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables,
} from '../../../../generated/graphql';
import {propagateErrorsContext} from '../../../../util/errors';
import {type QueryVars, type queryVars} from './queryVars';
import {
  type BackendLinesQueryPromise,
  type BucketedQueryPromise,
  type GroupedBackendLinesQueryPromise,
} from './types';

export function doBackendLinesApiQuery(
  vars: ReturnType<typeof queryVars>,
  currentRuns: string[],
  lastUpdated: string
): BackendLinesQueryPromise {
  return apolloClientNoCache.query<
    BackendLinesDeltaQueryQuery,
    BackendLinesDeltaQueryQueryVariables
  >({
    context: propagateErrorsContext(),
    query: BackendLinesDeltaQueryDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export function doGroupedBackendLinesApiQuery(
  vars: ReturnType<typeof queryVars>,
  currentRuns: string[],
  lastUpdated: string
): GroupedBackendLinesQueryPromise {
  return apolloClientNoCache.query<
    GroupedBackendLinesDeltaQueryQuery,
    GroupedBackendLinesDeltaQueryQueryVariables
  >({
    context: propagateErrorsContext(),
    query: GroupedBackendLinesDeltaQueryDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export function doBackendLinesApiQueryByInternalId(
  vars: ReturnType<typeof queryVars>,
  currentRuns: string[],
  lastUpdated: string
): BackendLinesQueryPromise {
  return apolloClientNoCache.query<
    BackendLinesDeltaQueryInternalIdQuery,
    BackendLinesDeltaQueryInternalIdQueryVariables
  >({
    context: propagateErrorsContext(),
    query: BackendLinesDeltaQueryInternalIdDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export function doBucketedApiQuery(
  vars: ReturnType<typeof queryVars>,
  currentRuns: string[],
  lastUpdated: string
): BucketedQueryPromise {
  return apolloClientNoCache.query<
    BucketedRunsDeltaQueryWithoutRunInfoQuery,
    BucketedRunsDeltaQueryWithoutRunInfoQueryVariables
  >({
    context: propagateErrorsContext(),
    query: BucketedRunsDeltaQueryWithoutRunInfoDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export function doBucketedApiQueryByInternalId(
  vars: QueryVars,
  currentRuns: string[],
  lastUpdated: string
): BucketedQueryPromise {
  return apolloClientNoCache.query<
    BucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
    BucketedRunsDeltaQueryWithoutRunInfoQueryVariables
  >({
    context: propagateErrorsContext(),
    query: BucketedRunsDeltaQueryWithoutRunInfoDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export type GroupedBucketedQueryPromise = Promise<
  ApolloQueryResult<GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery>
>;

export function doGroupedBucketedApiQuery(
  vars: QueryVars,
  currentRuns: string[],
  lastUpdated: string
): GroupedBucketedQueryPromise {
  return apolloClientNoCache.query<
    GroupedBucketedRunsDeltaQueryWithoutRunInfoQuery,
    GroupedBucketedRunsDeltaQueryWithoutRunInfoQueryVariables
  >({
    context: propagateErrorsContext(),
    query: GroupedBucketedRunsDeltaQueryWithoutRunInfoDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}

export function doGroupedBucketedApiQueryByInternalId(
  vars: ReturnType<typeof queryVars>,
  currentRuns: string[],
  lastUpdated: string
): GroupedBucketedQueryPromise {
  return apolloClientNoCache.query<
    GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQuery,
    GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoQueryVariables
  >({
    context: propagateErrorsContext(),
    query: GroupedBucketedRunsDeltaQueryInternalIdWithoutRunInfoDocument,
    fetchPolicy: 'no-cache',
    variables: {
      ...vars,
      currentRuns,
      lastUpdated,
    },
  });
}
